import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import { FormControl, FormControlLabel } from "material-ui/Form";
import MenuItem from "material-ui/Menu/MenuItem";
import Select from "material-ui/Select";
import Button from "../../../Parts/Button";
import { SalesforceObjectType } from "../../../../constants/ComponentTypes";
import Radio, { RadioGroup } from "material-ui/Radio";

const styles = () => ({
  root: {
    padding: "60px 0",
    width: "100%",
  },

  box: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    border: "1px solid #E7E9EB",
    background: "#FFFFFF",
    padding: "40px 44px",
    width: "492px",
    boxSizing: "border-box",
    margin: "auto",
  },

  title: {
    fontWeight: "bold",
    fontSize: "18px",
    marginBottom: "26px",
  },

  formControl: {
    width: "100%",
    marginLeft: "36px",
    flexDirection: "row",
    marginBottom: "45px",
  },

  buttonContainer: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
  },

  formControlLabel: {
    fontSize: "15px",
    color: "#181819",
  },
});

class SalesforceSelectListview extends React.Component {
  state = {
    importFromListview: "false",
    listview_id: 0,
  };

  componentWillMount() {
    if (this.props.listview_id === null) {
      this.setState({
        listview_id: 0,
        importFromListview: "false",
      });
    } else {
      this.setState({
        importFromListview: "true",
        listview_id: this.props.listview_id,
      });
    }
  }

  handleChange = (property) => (e) => {
    let value = e.target.value;
    if (property === "importFromListview") {
      if (value === "false") {
        this.setState({
          listview_id: 0,
        });
      }
    }

    this.setState({
      [property]: value,
    });
  };

  render() {
    const { classes, sobject, listviews } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.box}>
          <Typography variant="title" className={classes.title}>
            リストビューを選択
          </Typography>

          <RadioGroup
            aria-label="gender"
            name="gender2"
            value={this.state.importFromListview}
            onChange={this.handleChange("importFromListview")}
          >
            <FormControlLabel
              value="false"
              control={<Radio color="primary" />}
              label={
                SalesforceObjectType[sobject.toUpperCase()].text +
                "の全てのレコードを同期する"
              }
              classes={{ label: classes.formControlLabel }}
            />
            <FormControlLabel
              value="true"
              control={<Radio color="primary" />}
              label={
                SalesforceObjectType[sobject.toUpperCase()].text +
                "のリストビューから同期する"
              }
              classes={{ label: classes.formControlLabel }}
            />
          </RadioGroup>
          <FormControl
            className={classes.formControl}
            disabled={this.state.importFromListview !== "true"}
          >
            <Select
              style={{ width: "90%" }}
              value={this.state.listview_id}
              onChange={this.handleChange("listview_id")}
              MenuProps={{
                getContentAnchorEl: null,
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
              }}
              disableUnderline
            >
              {this.state.listview_id === 0 && (
                <MenuItem key={-1} value={0}>
                  選択してください
                </MenuItem>
              )}

              {listviews.map((item, i) => (
                <MenuItem key={i} value={item.id}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <div className={classes.buttonContainer}>
            <Button
              text="戻る"
              type="line"
              size="large"
              handleClickButton={this.props.prev}
              style={{ marginRight: "20px" }}
            ></Button>
            <Button
              text="次へ"
              size="large"
              loading={this.props.isLoadingFields}
              disabled={
                this.state.importFromListview === "true" &&
                this.state.listview_id === 0
              }
              handleClickButton={() => {
                this.props.handleSelectListview(
                  this.state.importFromListview === "true",
                  this.state.listview_id
                );
                this.props.next();
              }}
            ></Button>
          </div>
        </div>
      </div>
    );
  }
}

SalesforceSelectListview.propTypes = {
  classes: PropTypes.object.isRequired,
  sobject: PropTypes.string,
  listviews: PropTypes.array,
  listview_id: PropTypes.number,
  isLoadingFields: PropTypes.bool,
  handleSelectListview: PropTypes.func,
  next: PropTypes.func,
  prev: PropTypes.func,
};

export default withStyles(styles)(SalesforceSelectListview);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/SalesforceAddressSetting/SalesforceSelectListview.jsx